import * as yup from "yup";

export const EmployeeInputs = {
    FIRSTNAME: "firstname",
    MIDDLENAME: "middlename",
    LASTNAME: "lastname",
    PREFERRED_NAME: "preferred_name",
    SOCIAL_SECURITY_NUMBER: "social_security_number",
    BIRTH_DATE: "birth_date",
    MARITAL_STATUS: "marital_status",
    ADDRESS: "address",
    CITY: "city",
    STATE: "state",
    ZIP_CODE: "zip_code",
    EMAIL: "email",
    HOME_PHONE: "home_phone",
    CELL_PHONE: "cell_phone",
    JOB_TITLE: "job_title",
    DEPARTMENT: "department",
    EMPLOYMENT_TYPE: "employment_type",
    IS_REG_EMAIL: "is_reg_email",
    ACTIVE_STATUS: "active_status",
    WORK_FROM_HOME: "work_from_home",
    WORK_LOCATION: "work_location",
    WORK_TIME_ZONE: "work_time_zone",
    WAGE: "wage",
    WAGE_PERIOD: "wage_period",
    OVERTIME_EXEMPT_STATUS: "overtime_exempt_status",
    SUPPLEMENT_TAX_METHOD: "supplement_tax_method",
    PAY_TYPE: "pay_type",
    FULL_TIME_HOURS: "full_time_hours",
    PAYMENT_METHOD: "payment_method",
    FEDERAL_FILING_STATUS: "federal_filing_status",
    FEDERAL_EXEMPT: "federal_exempt",
    FEDERAL_EXTRA_WITHHOLDING: "federal_extra_withholding",
    MULTIPLE_JOBS: "multiple_jobs",
    DEPENDENTS_AMOUNT: "dependents_amount",
    OTHER_INCOME: "other_income",
    DEDUCTIONS_AMOUNT: "deductions_amount",
    STATE_FILING_STATUS: "state_filing_status",
    STATE_ALLOWANCES: "state_allowances",
    RESIDENT_STATE: "resident_state",
    WORK_STATE: "work_state",
    START_DATE: "start_date",
    TERMINATION_DATE: "termination_date",
    // Emergency Contact
    EMERGENCY_FIRST_NAME: "emergency_first_name",
    EMERGENCY_LAST_NAME: "emergency_last_name",
    EMERGENCY_RELATIONSHIP: "emergency_relationship",
    EMERGENCY_PHONE: "emergency_phone",
    EMERGENCY_ALT_PHONE: "emergency_alt_phone",
    EMERGENCY_EMAIL: "emergency_email",
    // Work Eligibility
    US_CITIZEN: "us_citizen",
    AUTHORIZED_TO_WORK: "authorized_to_work",
    WORK_AUTH_TYPE: "work_auth_type",
    WORK_AUTH_EXPIRY: "work_auth_expiry",
    REHIRE: "rehire",
    I9_SECTION1: "i9_section1",
    I9_DATE: "i9_date",
    PRIMARY_WORK_STATE: "primary_work_state",
    REMOTE_WORK_STATE: "remote_work_state",
    WORKERS_COMP_CODE: "workers_comp_code",
    LOCAL_TAX_AREA: "local_tax_area",
    LOCATION_ID: "location_id",
};

export const employeeSchema = yup.object({
    [EmployeeInputs.FIRSTNAME]: yup.string().required("Please enter firstname"),
    [EmployeeInputs.MIDDLENAME]: yup.string().optional().nullable(),
    [EmployeeInputs.LASTNAME]: yup.string().required("Please enter lastname"),
    [EmployeeInputs.SOCIAL_SECURITY_NUMBER]: yup.string().required("SSN is required").matches(/^\d{3}-\d{2}-\d{4}$/, "SSN must be in format ###-##-####"),
    [EmployeeInputs.BIRTH_DATE]: yup.string().required("Date of birth is required")
        .test('dob-valid', 'Please enter a valid date of birth', v => !!v && !isNaN(Date.parse(v)))
        .test('dob-past', 'Date of birth must be in the past', v => !!v && new Date(v) < new Date()),
    [EmployeeInputs.MARITAL_STATUS]: yup.string().optional().nullable(),
    [EmployeeInputs.ADDRESS]: yup.string().required("Address is required"),
    [EmployeeInputs.CITY]: yup.string().required("City is required"),
    [EmployeeInputs.STATE]: yup.string().required("State is required"),
    [EmployeeInputs.ZIP_CODE]: yup.string().required("Zip code is required").matches(/^\d{5}(-\d{4})?$/, "ZIP code must be 5 digits (e.g. 37130)"),
    [EmployeeInputs.EMAIL]: yup.string().required("Email is required").email("Please enter valid email"),
    [EmployeeInputs.HOME_PHONE]: yup.string().nullable().optional().test('home-phone', 'Home phone must be 10 digits', val => !val || val.replace(/\D/g, '').length === 10),
    [EmployeeInputs.CELL_PHONE]: yup.string().required("Cell phone is required").test('cell-phone', 'Cell phone must be 10 digits', val => !val || val.replace(/\D/g, '').length === 10),
    [EmployeeInputs.ACTIVE_STATUS]: yup.string().optional().nullable(),
    [EmployeeInputs.WORK_FROM_HOME]: yup.string().optional().nullable(),
    [EmployeeInputs.WORK_LOCATION]: yup.string().optional().nullable(),
    [EmployeeInputs.LOCATION_ID]: yup.string().optional().nullable(),
    [EmployeeInputs.WORK_TIME_ZONE]: yup.string().optional().nullable(),
    [EmployeeInputs.WAGE]: yup.string().required("Pay rate is required"),
    [EmployeeInputs.WAGE_PERIOD]: yup.string().optional().nullable(),
    [EmployeeInputs.PAY_TYPE]: yup.string().required("Pay type is required"),
    [EmployeeInputs.FULL_TIME_HOURS]: yup.string().optional().nullable(),
    [EmployeeInputs.OVERTIME_EXEMPT_STATUS]: yup.string().required("FLSA overtime exempt status is required"),
    [EmployeeInputs.SUPPLEMENT_TAX_METHOD]: yup.string().optional().nullable(),
    [EmployeeInputs.FEDERAL_FILING_STATUS]: yup.string().required("Federal filing status is required"),
    [EmployeeInputs.FEDERAL_EXEMPT]: yup.boolean().optional().nullable(),
    [EmployeeInputs.FEDERAL_EXTRA_WITHHOLDING]: yup.string().optional().nullable(),
    [EmployeeInputs.MULTIPLE_JOBS]: yup.string().optional().nullable(),
    [EmployeeInputs.DEPENDENTS_AMOUNT]: yup.string().optional().nullable(),
    [EmployeeInputs.OTHER_INCOME]: yup.string().optional().nullable(),
    [EmployeeInputs.DEDUCTIONS_AMOUNT]: yup.string().optional().nullable(),
    [EmployeeInputs.STATE_FILING_STATUS]: yup.string().required("State filing status is required"),
    [EmployeeInputs.RESIDENT_STATE]: yup.string().required("Resident state is required"),
    [EmployeeInputs.WORK_STATE]: yup.string().required("Work state is required"),
    [EmployeeInputs.START_DATE]: yup.string().required("Start date is required"),
    [EmployeeInputs.TERMINATION_DATE]: yup.string().optional().nullable(),
    [EmployeeInputs.PREFERRED_NAME]: yup.string().optional().nullable(),
    [EmployeeInputs.JOB_TITLE]: yup.string().optional().nullable(),
    [EmployeeInputs.DEPARTMENT]: yup.string().optional().nullable(),
    [EmployeeInputs.EMPLOYMENT_TYPE]: yup.string().required("Employment type is required"),
    [EmployeeInputs.EMERGENCY_FIRST_NAME]: yup.string().optional().nullable(),
    [EmployeeInputs.EMERGENCY_LAST_NAME]: yup.string().optional().nullable(),
    [EmployeeInputs.EMERGENCY_RELATIONSHIP]: yup.string().optional().nullable(),
    [EmployeeInputs.EMERGENCY_PHONE]: yup.string().nullable().optional().test('emrg-phone', 'Emergency phone must be 10 digits', val => !val || val.replace(/\D/g, '').length === 10),
    [EmployeeInputs.EMERGENCY_ALT_PHONE]: yup.string().nullable().optional().test('emrg-alt-phone', 'Alternate phone must be 10 digits', val => !val || val.replace(/\D/g, '').length === 10),
    [EmployeeInputs.EMERGENCY_EMAIL]: yup.string().nullable().optional().test('emrg-email', 'Please enter a valid email', val => !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)),
    [EmployeeInputs.US_CITIZEN]: yup.string().optional().nullable(),
    [EmployeeInputs.AUTHORIZED_TO_WORK]: yup.string().optional().nullable(),
    [EmployeeInputs.WORK_AUTH_TYPE]: yup.string().optional().nullable(),
    [EmployeeInputs.WORK_AUTH_EXPIRY]: yup.string().optional().nullable(),
    [EmployeeInputs.REHIRE]: yup.string().optional().nullable(),
    [EmployeeInputs.I9_SECTION1]: yup.string().optional().nullable(),
    [EmployeeInputs.I9_DATE]: yup.string().optional().nullable(),
    [EmployeeInputs.PRIMARY_WORK_STATE]: yup.string().optional().nullable(),
    [EmployeeInputs.REMOTE_WORK_STATE]: yup.string().optional().nullable(),
    [EmployeeInputs.WORKERS_COMP_CODE]: yup.string().optional().nullable(),
    [EmployeeInputs.PAY_SCHEDULE]: yup.string().optional().nullable(),
});







